





























































































































































import { Component, Vue, Prop, Emit,Watch } from 'vue-property-decorator'
import { CareateGoods,QueryGoodsByCodee,UpdateGoods, QueryAllShopNameList, QuerySupplierList,QueryConfigLIst,GoodsAuditPass,GoodsAuditReject, QueryAllInvoiceTypeList, QueryCouponTemplateList } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'
import { getByParentId, get, loadClassifyTree } from '@/store/classifyStore'
import { VImageUpload } from '@/components/upload'
import {getUser} from '@/store/userStore'
import GoodsSpecifications from './components/GoodsSpecifications.vue'
import GoodsSkus from './components/GoodsSkus.vue'
import draggable from "vuedraggable";

@Component({
  components: {
    VImageUpload,
    GoodsSpecifications,
    GoodsSkus,
    draggable
  },
})
export default class CreateGoodsDialog extends Vue {
  private readonly couponAllowedShopId = 100009
  private couponTemplateOptions: any[] = []
  private show = false
  private activeIndex =  "BaseInfoRef"
  private sectionOffsets:Array<any> = [] // 存储区块位置信息
  private data:any = {
    goodsBannersGileList: [],
    goodsDescImgsGileList: [],
    goodsBanners: '',
    goodsDescImgs: '',
    settlementAmount: 0,
    salesIntegral: 0,
    preferentialIntegral: 0,
    rewardIntegral: 0,
    profferValue: 0,
    capacityValue: 0,
    goodsOneClassifyId: undefined,
    goodsTwoClassifyId: undefined,
    goodsThreeClassifyId: undefined,
    invoiceType: undefined, // 发票类型
    invoiceTaxRate: undefined, // 发票税率
    distributionGoodsFlag: 0,
    specialPriceGoodsFlag: 0,
    repurchaseGoodsFlag: 0,
    wealthPayLimitEnabled: 0,
    maxWealthPayRatio: undefined,
    couponEnabled: 0,
    couponTemplateIds: [],
    deliverySupportType: 0,
    indexMainPushFlag: 0,
    indexMainPushEndTime: '',
    indexMainPushSort: 0,
    indexPreviewFlag: 0,
    indexPreviewStartTime: '',
    indexPreviewSort: 0,
    indexSalePriceImg: '',
    indexSalePriceImgFileList: [],
    sort: 0,
    specTypeList:[{
      id: undefined,
      name: '',
      specItemList: [],
      sort: 0
    }],
    goodsSkuList:[],
    minPrice: 0,
    maxPrice: 0,
    showPrice: 0, // 显示的价格
    inventory:0,
    buyCount: 0,
    marketPrice:0,
    minPv:0,
    maxPv:0,
    paiduiRate: undefined, // 排队比率（百分比）
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    supplierCode: [this.requiredRule],
    shopId: [this.requiredRule],
    goodsName: [this.requiredRule],
    goodsUnit: [this.requiredRule],
    salesIntegral: [this.requiredRule],
    goodsBanners: [this.requiredRule],
    goodsDescImgs: [this.requiredRule],
    specTypeList: [this.requiredRule,{
      validator: (rule:any, value:any, callback:any) => {
        console.log("value")
        console.log(value)
        // 有效规格数量
        let c = 0
        for(const t of value){
          c+=t.specItemList.length
        }
        if (c > 0) {
          callback();
        } else {
          callback(new Error('至少填写一个规格'));
        }
      },
      trigger: 'change'
    }],
    goodsSkuList: [this.requiredRule],
   " goodsSkuList.price": [this.requiredRule],

  }
  private supplierOption: Array<any> = []
  private shopIdOption: Array<any> = []
  private invoiceTypeOption: Array<any> = []

  private  userInfo = getUser()

  get couponShopAllowed(): boolean {
    const sid = Number(this.data.shopId)
    return sid === this.couponAllowedShopId
  }

  @Watch('data.shopId')
  private onShopIdForCoupon(): void {
    if (!this.couponShopAllowed) {
      this.data.couponEnabled = 0
      this.data.couponTemplateIds = []
    }
  }

  private get formDisabled(){
    if(this.type == 'add'){
      return false
    }
    // 不为店铺帐号 则不禁用
    if(this.userInfo.user.role != 2){
      return false
    }

    if(this.data.goodsStatus != 0 && this.data.goodsStatus != 3 ){
      return true
    }
    return false
  }

  @Watch('data.goodsSkuList',{deep: true})
  private goodsSkuListWatch() {
    // 跟新库存和价格
    if(!this.data.goodsSkuList || this.data.goodsSkuList.length == 0){
      this.data.minPrice = 0
      this.data.maxPrice = 0
      this.data.inventory = 0
      this.data.showPrice = undefined
      this.data.minPv = 0
      this.data.maxPv = 0
      return
    }
    const prices: number[] = this.data.goodsSkuList.filter((e: any)=>e.price).map((e: any)=>Number(e.price))
    if(prices && prices.length>0){
      this.data.minPrice = Math.min(...prices)
      this.data.maxPrice = Math.max(...prices)
    } else {
      this.data.minPrice = 0
      this.data.maxPrice = 0
    }
    const pvs: number[] = this.data.goodsSkuList.filter((e: any)=>e.pv).map((e: any)=>Number(e.pv))
    if(pvs && pvs.length>0){
      this.data.minPv = Math.min(...pvs)
      this.data.maxPv = Math.max(...pvs)
    } else {
      this.data.minPv = 0
      this.data.maxPv = 0
    }
    this.data.inventory = this.data.goodsSkuList.reduce((sum:number, sku:any) => {
      let res = 0
      if(sku.inventory && sku.inventory>0) {
        res += Number(sku.inventory)
      }
      if(sku.inStockInventory && sku.inStockInventory>0) {
        res += Number(sku.inStockInventory)
      }
      if(res < 0){
        res = 0
      }
      return sum + res
    }, 0)
    if(this.data.minPrice == this.data.maxPrice){
      this.data.showPrice = this.data.minPrice
    } else {
      this.data.showPrice = this.data.minPrice + '~' + this.data.maxPrice
    }

  }



  private classifyTree(parentId: number) {
    return getByParentId(parentId)
  }

  public async created() {
    this.loadSupplier()
    this.loadShop()
    this.loadQueryConfigList()
    this.loadInvoiceTypeList()
    // 初始化区块位置信息
    // this.calculateSectionPositions();

  }

  // 加载配置
  private buyGxRate = 1.5
  private buyNlRate = 2
	private loadQueryConfigList() {
    // 判断店铺类型
    const role = this.userInfo.user.role
    const directSales = this.userInfo?.user?.shop?.directSales
    if(role == '2' && !directSales){
      // 店铺账号，非直营店铺，贡献值和能量值固定为5倍
      this.buyGxRate = 5
      this.buyNlRate = 3 // 能量值默认为3倍
    } else {
      QueryConfigLIst({pageSize: 100}).then(res => {
        if(res.list  && res.length >  0){
          for(const c of res.list){
            if(c.configParam == 'buyGxRate'){
              this.buyGxRate = parseFloat(Number(c.configValue / 100).toFixed(2))
            }
            if(c.configParam == 'buyNlRate'){
              this.buyNlRate = parseFloat(Number(c.configValue / 100).toFixed(2))
            }
          }
        }
      })
    }
    console.log('this.buyGxRate')
    console.log(this.buyGxRate)

	}

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

  }
  private async loadSupplier() {
    const res = await QuerySupplierList({})
    const list = res.list
    this.supplierOption = list.map((e: any) => {
      return { value: e.supplierCode, label: e.supplierSimpleName }
    })
  }
  private async loadInvoiceTypeList() {
    const res = await QueryAllInvoiceTypeList()
    if (res && Array.isArray(res)) {
      this.invoiceTypeOption = res
    } else if (res && res.list) {
      this.invoiceTypeOption = res.list
    }
  }
  private invoiceTypeChange(value: any) {
    // 当选择发票类型时，自动填充默认税率
    const selectedType = this.invoiceTypeOption.find((item: any) => item.typeCode === value)
    if (selectedType && selectedType.defaultTaxRate) {
      this.data.invoiceTaxRate = selectedType.defaultTaxRate
    }
  }
  @Emit('close')
  private close() {
    const gsRef = this.$refs.GoodsSkus as GoodsSkus
    gsRef.clearParam()

    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {
      goodsBannersGileList: [],
      goodsDescImgsGileList: [],
      goodsBanners: '',
      goodsDescImgs: '',
      settlementAmount: 0,
      salesIntegral: 0,
      preferentialIntegral: 0,
      rewardIntegral: 0,
      profferValue: 0,
      capacityValue: 0,
      goodsOneClassifyId: undefined,
      goodsTwoClassifyId: undefined,
      goodsThreeClassifyId: undefined,
      invoiceType: undefined, // 发票类型
      invoiceTaxRate: undefined, // 发票税率
      distributionGoodsFlag: 0,
    specialPriceGoodsFlag: 0,
      repurchaseGoodsFlag: 0,
      wealthPayLimitEnabled: 0,
      maxWealthPayRatio: undefined,
      deliverySupportType: 0,
      indexMainPushFlag: 0,
      indexMainPushEndTime: '',
      indexMainPushSort: 0,
      indexPreviewFlag: 0,
      indexPreviewStartTime: '',
      indexPreviewSort: 0,
    indexSalePriceImg: '',
    indexSalePriceImgFileList: [],
      sort: 0,
      specTypeList:[],
      goodsSkuList:[],
      minPrice: 0,
      maxPrice: 0,
      showPrice: 0, // 显示的价格
      inventory: 0,
      buyCount: 0,
      marketPrice: 0,
      paiduiRate: undefined,
    }
  }
  private type = 'add'
  public async open(type:string|undefined = 'add',goodsCode:string|undefined = undefined) {
    this.couponTemplateOptions = (await QueryCouponTemplateList({ enabledOnly: true })) || []
    this.show = true
    this.type = type
    if (!get().child || get().child.length === 0) {
      await loadClassifyTree()
    }
    if(goodsCode){
      this.loadGoodsDetail(goodsCode)
    }
    // 计算组件位置
    this.calculateSectionPositions()
  }

  private async loadGoodsDetail(goodsCode: string){
    const res = await QueryGoodsByCodee({goodsCode})
    // 处理数据

    if (res.goodsBanners) {
      res.goodsBannersGileList = res.goodsBanners.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      res.goodsBannersGileList = []
    }
    if (res.goodsDescImgs) {
      res.goodsDescImgsGileList = res.goodsDescImgs.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      res.goodsDescImgsGileList = []
    }

    res.settlementAmount = res.settlementAmount / 100
    res.salesIntegral = res.salesIntegral / 100
    res.preferentialIntegral = res.preferentialIntegral / 100
    res.rewardIntegral = res.rewardIntegral / 100
    res.profferValue = res.profferValue / 100
    res.capacityValue = res.capacityValue / 100
    // 处理价格
    res.minPrice = res.minPrice / 100
    res.maxPrice =res.maxPrice / 100
    res.marketPrice = res.marketPrice / 100
    res.minPv = res.minPv / 100
    res.maxPv = res.maxPv / 100
    res.distributionGoodsFlag = res.distributionGoodsFlag === 1 ? 1 : 0
    res.specialPriceGoodsFlag = res.specialPriceGoodsFlag === 1 ? 1 : 0
    res.repurchaseGoodsFlag = res.repurchaseGoodsFlag === 1 ? 1 : 0
    res.wealthPayLimitEnabled = res.wealthPayLimitEnabled === 1 ? 1 : 0
    if (res.wealthPayLimitEnabled !== 1) {
      res.maxWealthPayRatio = undefined
    }
    res.couponEnabled = res.couponEnabled === 1 ? 1 : 0
    res.couponTemplateIds = res.couponTemplateIds || []
    const dst = res.deliverySupportType
    res.deliverySupportType = dst === null || dst === undefined || dst === '' ? 0 : Number(dst)
    res.indexMainPushFlag = res.indexMainPushFlag === 1 ? 1 : 0
    res.indexPreviewFlag = res.indexPreviewFlag === 1 ? 1 : 0
    res.indexMainPushSort = res.indexMainPushSort != null ? res.indexMainPushSort : 0
    res.indexPreviewSort = res.indexPreviewSort != null ? res.indexPreviewSort : 0
    if (res.indexSalePriceImg) {
      res.indexSalePriceImgFileList = [{ url: res.indexSalePriceImg }]
    } else {
      res.indexSalePriceImgFileList = []
    }
    res.buyCount = res.buyCount != null ? res.buyCount : 0
    // 处理sku的价格
    res.goodsSkuList.forEach((e: any)=>{
      e.price = e.price/100
      e.pv = e.pv / 100
      if (e.repurchasePrice != null) e.repurchasePrice = e.repurchasePrice / 100
      if (e.repurchasePv != null) e.repurchasePv = e.repurchasePv / 100
    })
    // 处理规格

    this.data = res
  }

  private onDistributionGoodsFlagChange(val: number) {
    if (val === 1) {
      this.data.specialPriceGoodsFlag = 0
    }
  }

  private onSpecialPriceGoodsFlagChange(val: number) {
    if (val === 1) {
      this.data.distributionGoodsFlag = 0
      this.data.repurchaseGoodsFlag = 0
    }
  }

  private onRepurchaseGoodsFlagChange(val: number) {
    if (val === 1) {
      this.data.specialPriceGoodsFlag = 0
    }
  }

  public async save() {

    this.data.goodsBanners = this.data.goodsBannersGileList.map((e: any) => e.url).join(',')
    this.data.goodsDescImgs = this.data.goodsDescImgsGileList.map((e: any) => e.url).join(',')
    this.data.indexSalePriceImg = this.data.indexSalePriceImgFileList.length
      ? this.data.indexSalePriceImgFileList[0].url
      : ''

    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        this.$message.warning("尚有信息有误，请完善")
        return
      }
      if (this.data.wealthPayLimitEnabled === 1) {
        const r = Number(this.data.maxWealthPayRatio)
        if (!r || r < 1 || r > 100) {
          this.$message.warning('已开启限制抵扣，请填写 1～100 的整数占比')
          return
        }
      }
      const param = JSON.parse(JSON.stringify(this.data))
      if (param.wealthPayLimitEnabled !== 1) {
        param.wealthPayLimitEnabled = 0
        param.maxWealthPayRatio = null
      }
      if (param.couponEnabled === 1) {
        if (Number(param.shopId) !== this.couponAllowedShopId) {
          this.$message.warning(`仅店铺ID ${this.couponAllowedShopId} 可配置优惠券`)
          return
        }
        if (!param.couponTemplateIds || !param.couponTemplateIds.length) {
          this.$message.warning('开启优惠券后请至少选择一个券模板')
          return
        }
      } else {
        param.couponEnabled = 0
        param.couponTemplateIds = []
      }

      param.settlementAmount = param.settlementAmount * 100
      param.salesIntegral = param.salesIntegral * 100
      param.preferentialIntegral = param.preferentialIntegral * 100
      param.rewardIntegral = param.rewardIntegral * 100
      param.profferValue = param.profferValue * 100
      param.capacityValue = param.capacityValue * 100
      // 处理价格
      param.minPrice = (param.minPrice * 100).toFixed(0)
      param.maxPrice = (param.maxPrice * 100).toFixed(0)
      param.marketPrice = (param.marketPrice * 100).toFixed(0)
      param.minPv = (param.minPv * 100).toFixed(0)
      param.maxPv = (param.maxPv * 100).toFixed(0)
      // 处理sku的价格
      for(const e of param.goodsSkuList){
        if(!e.price || e.price <= 0){
          this.$message.error("SKU价格不能小于0")
          return
        }
        e.price = (e.price * 100).toFixed(0)
        if(!e.pv){
          e.pv = 0
        }
        e.pv = (e.pv * 100).toFixed(0)
        if (param.repurchaseGoodsFlag === 1) {
          if (e.repurchasePrice != null && e.repurchasePrice !== '') {
            e.repurchasePrice = (e.repurchasePrice * 100).toFixed(0)
          }
          if (e.repurchasePv != null && e.repurchasePv !== '') {
            e.repurchasePv = (e.repurchasePv * 100).toFixed(0)
          }
        }
      }
      // param.goodsSkuList.forEach((e: any)=>{

      // })

      if(param.id){
        param.indexMainPushFlag = param.indexMainPushFlag === 1 ? 1 : 0
        param.indexPreviewFlag = param.indexPreviewFlag === 1 ? 1 : 0
        if (param.indexMainPushFlag !== 1) {
          param.indexMainPushEndTime = null
        }
        if (param.indexPreviewFlag !== 1) {
          param.indexPreviewStartTime = null
        }
        UpdateGoods(param).then(res=>{
          if(res){
            this.$message.success('修改成功')
            this.close()
          }
        })
      } else {
        CareateGoods(param).then(res=>{
          if(res){
            this.$message.success('保存成功')
            this.close()
          }
        })
      }


    })
  }

  private handleSelect(index: string){
    this.activeIndex = index
    const indexRef = this.$refs[index] as any;
    indexRef.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }
  // 计算各区块的位置
  private calculateSectionPositions() {
      // 使用 $nextTick 确保 DOM 更新完成
      this.$nextTick(() => {
        const positions: Array<any> = [];

        ["BaseInfoRef", "TuwenInfoRef", "PriceInfoRef","ServeInfoRef"].forEach(id => {
          const element = document.getElementById(id);
          if (element) {
            positions.push({
              id,
              offsetTop: element.offsetTop,
              height: element.offsetHeight,
            });
          }
        });

        this.sectionOffsets = positions;
      })
    }
  // 滚动时更新高亮菜单
  private handleScroll(ddd: any) {
      const element:any = document.getElementById('goodsView');
      const scrollPosition = element.scrollTop + 100; // 加一个偏移量（比如菜单高度）

      // 遍历所有区块，找到当前在视口中的区块
      for (const section of this.sectionOffsets) {
        if (
          scrollPosition >= section.offsetTop &&
          scrollPosition < section.offsetTop + section.height
        ) {
          this.activeIndex = section.id;
          break;
        }
      }
    }

    private goodsOneClassifyIdChange(){
      this.data.goodsTwoClassifyId = null
      this.data.goodsThreeClassifyId = null
    }

    private goodsTwoClassifyIdChange(){
      this.data.goodsThreeClassifyId = null
    }

    private auditPass(){
      // 审核通过
      this.$confirm("是否审核通过，通过后商品将自动上架", '提示', {
        type: 'warning'
      }).then(() => {
        GoodsAuditPass({
          id: this.data.id,
        }).then(res=>{
          this.$message.success("审核通过")
          this.close()
        })
      })
    }

    private auditReject(){
      // 审核失败
      this.$prompt("请填写审核失败原因：", '提示', {
        type: 'warning'
      }).then((md:any) => {
        GoodsAuditReject({
          id: this.data.id,
          auditRejectMsg: md.value,
        }).then(res=>{
          this.$message.success("审核失败")
          this.close()
        })
      })
    }

}
